import React, { useEffect, useRef, useState } from "react";
import "../../css/loginPage.css";
import headerlogo from "../../images/leslogo.svg";
import * as Yup from "yup";
import { useFormik } from "formik";

const Login = () => {
  let url = "https://server.launchestore.com/";
  // let url = "https://staggingnode.launchestore.com/";
  const [step1, setstep1] = React.useState(true);
  const [timer, setTimer] = useState(300); // 5-minute countdown
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .required("Please enter Email")
      .email("Please enter valid Email"),
  });

  useEffect(() => {
    if (!step1) {
      // Wait a short moment for DOM update
      setTimeout(() => {
        if (inputs.current[0]) {
          inputs.current[0].focus();
        }
      }, 50);
    }
  }, [step1]);

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        setError("");
        setSuccess("");
        inputs.current.forEach((input) => {
          if (input) input.value = "";
        });
        fetch(`${url}vendor/sendOtpMailRegister`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json", // Remove this line for FormData
          },
          body: JSON.stringify({
            email: values.email.trim(),
            isVendorLogin: "1",
          }), // Pass FormData as the body
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.success) {
              setSuccess(data.message);
              setstep1(false);
              setIsResendDisabled(true);
              setTimer(300);
              if (inputs.current[0]) {
                inputs.current[0].focus();
              }
            } else {
              setError(data.message);
              resetOtpInputs(); // 🔥 Clear and auto-focus
            }
          })
          .catch((e) => {
            setError(e.message);
            resetOtpInputs(); // 🔥 Clear and auto-focus
          });
      } catch (error) {
        resetOtpInputs(); // 🔥 Clear and auto-focus
        setError(error.message);
      } finally {
        formik.setSubmitting(false);
      }
    },
  });

  useEffect(() => {
    if (!isResendDisabled) return;

    const endTime = Date.now() + timer * 1000;

    const interval = setInterval(() => {
      const remaining = Math.max(0, Math.floor((endTime - Date.now()) / 1000));
      setTimer(remaining);

      if (remaining === 0) {
        setIsResendDisabled(false);
        clearInterval(interval);
      }
    }, 500); // Check twice per second for better accuracy

    return () => clearInterval(interval);
  }, [isResendDisabled]);

  const inputs = useRef([]);

  const handleChange = (e, index) => {
    setError("");
    const value = e.target.value;
    if (/^[0-9]$/.test(value)) {
      if (index < inputs.current.length - 1) {
        inputs.current[index + 1].focus();
      }
    } else {
      e.target.value = "";
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      inputs.current[index - 1].focus();
    }
  };

  // format time as mm:ss
  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

  const handleOtpVerify = async () => {
    try {
      setLoading(true);
      const otp = inputs.current.map((i) => i.value).join("");

      const response = await fetch(`${url}vendor/emailVerifyOtp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: formik.values.email,
          otp: otp,
          isVendorLogin: "1",
        }),
      });

      const data = await response.json();

      if (!data.success) {
        setError(data.message);
        resetOtpInputs();
        return;
      }

      setSuccess(data.message);
      if (data.success) {
        setSuccess(data.message);
        if (!data?.data?.package_id) {
          window.location.href = `https://register.launchestore.com/?laststep=3&vendorId=${data?.data?.vendor_id}`;
        } else if (!data?.data?.theme_name) {
          window.location.href = `https://register.launchestore.com/?laststep=4&vendorId=${data?.data?.vendor_id}`;
        } else if (data.data.isRegister === "0") {
          window.location.href = `https://${data.data.domain_name}/admin/login?logtemptok=${data.data.temp_token}`;
        } else if (
          data.data.themedevelopverifytoken &&
          data.data.theme_develop_position === "0"
        ) {
          window.location.href = `https://${data.data.domain_name}/home?verifytoken=${data.data.themedevelopverifytoken}`;
        } else if (
          data.data.themedevelopverifytoken &&
          data.data.theme_develop_position === "1"
        ) {
          window.location.href = `https://${data.data.domain_name}/admin/login?logtemptok=${data.data.temp_token}`;
        }
        setLoading(false);
      } else {
        resetOtpInputs(); // 🔥 Clear and auto-focus
        setError(data.message);
        setLoading(false);
      }
    } catch (e) {
      setError(e.message);
      resetOtpInputs();
    } finally {
      setLoading(false);
    }
  };

  const resetOtpInputs = () => {
    inputs.current.forEach((input) => {
      if (input) input.value = "";
    });
    if (inputs.current[0]) {
      inputs.current[0].focus();
    }
  };

  const handleEnterKey = (e) => {
    if (e.key === "Enter") {
      if (step1) {
        formik.handleSubmit(); // Submit email
      } else {
        handleOtpVerify(); // Verify OTP
      }
    }
  };

  return (
    <div className="main-login-wraper">
      <div className="wrapper">
        <div className="left">
          {/* <div class="logo">
            <img src={headerlogo} alt="logo" />
          </div> */}

          <h1>Welcome Back!</h1>
          <p>
            Sign in to manage your products, view analytics, and grow your
            business.
          </p>

          <form onSubmit={formik.handleSubmit} className="disble-btn">
            <input
              type="email"
              placeholder="Enter your Email Address..."
              name="email"
              onChange={formik.handleChange}
              value={formik.values.email}
              onBlur={formik.handleBlur}
              disabled={!step1}
              onKeyDown={handleEnterKey}
            />
            {formik.touched.email && formik.errors.email && (
              <div className="error">{formik.errors.email}</div>
            )}

            {!step1 && (
              <div className="otp-container">
                {[0, 1, 2, 3].map((i) => (
                  <input
                    key={i}
                    type="text"
                    maxLength="1"
                    ref={(el) => (inputs.current[i] = el)}
                    onChange={(e) => handleChange(e, i)}
                    onKeyDown={(e) => {
                      handleKeyDown(e, i);
                      handleEnterKey(e);
                    }}
                    className="otp-box"
                  />
                ))}
              </div>
            )}
            {step1 && (
              <button
                type="submit"
                disabled={formik.isSubmitting}
                className="btn-dis"
              >
                {formik.isSubmitting ? (
                  <div className="loader"></div>
                ) : (
                  "Verify with OTP →"
                )}
              </button>
            )}
            {!step1 && (
              <>
                <button
                  type="button"
                  onClick={handleOtpVerify}
                  disabled={loading}
                  className="btn-dis"
                >
                  {loading ? <div className="loader"></div> : "Verify"}
                </button>
                <button
                  type="submit"
                  disabled={isResendDisabled}
                  className="btn-dis"
                >
                  Resend OTP
                </button>
                {isResendDisabled && (
                  <p
                    style={{
                      marginTop: "10px",
                      color: "#666",
                      width: "100%",
                      textAlign: "center",
                      maxWidth: "100%",
                    }}
                  >
                    You can resend OTP in <strong>{formatTime(timer)}</strong>
                  </p>
                )}
              </>
            )}
            {error !== "" && <div className="error text-center">{error}</div>}
            {success !== "" && error === "" && (
              <div className="success">{success}</div>
            )}
          </form>
        </div>

        <div class="right">
          <img src="/loginsideimage.png" alt="Team working dashboard" />
        </div>
      </div>
      {/* <ToastContainer /> */}
    </div>
  );
};

export default Login;
